// Flow types automatically removed

import { getSortValue, getSortUrlLabel } from './sortOptions';
export const queryParamKeys = {
    PAGE: 'page',
    LOCATION_FILTER: 'location',
    SORT_BY: 'sort',
    //the __tpnDisplay param is an eng only param; no UI components should
    //generate a url that includes it
    TPN_DISPLAY: '__tpnDisplay',
    TEST_FIRM: 'testFirms',
};
export const queryParamActions = {
    CHANGE_PAGE: 'CHANGE_PAGE',
    CHANGE_LOCATION_FILTER: 'CHANGE_LOCATION_FILTER',
    CHANGE_SORT_BY: 'CHANGE_SORT_BY',
};
export function mapQueryParamsToProps(queryParams) {
    let page = queryParams.readInt(queryParamKeys.PAGE) || 1;
    page = page < 1 ? 1 : page;
    const tpnDisplayValue = queryParams.readStr(queryParamKeys.TPN_DISPLAY);
    return {
        page,
        locationFilter: queryParams.readStr(queryParamKeys.LOCATION_FILTER),
        sortBy: getSortValue(queryParams.readStr(queryParamKeys.SORT_BY)),
        showOnlyTpnFirms: tpnDisplayValue !== 'N',
        showTestFirms:
            queryParams.readStr(queryParamKeys.TEST_FIRM) === 'Y' && tpnDisplayValue !== 'Y',
    };
}
export function mapUpdateToQueryParams(action, value) {
    switch (action) {
        case queryParamActions.CHANGE_PAGE:
            return {
                [queryParamKeys.PAGE]: value === 1 ? null : value,
            };

        case queryParamActions.CHANGE_LOCATION_FILTER:
            return {
                [queryParamKeys.PAGE]: null,
                [queryParamKeys.LOCATION_FILTER]: value,
            };

        case queryParamActions.CHANGE_SORT_BY:
            return {
                [queryParamKeys.PAGE]: null,
                [queryParamKeys.SORT_BY]: getSortUrlLabel(value),
            };

        default:
            return {};
    }
}
